import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api, errorText } from "../../lib/api";
import { useAuth } from "../../lib/auth";

export default function AuthCallback() {
  const { hash } = useLocation();
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    api.post("/auth/google/session", { session_id: sessionId })
      .then((r) => { setUser(r.data); navigate("/admin", { replace: true, state: { user: r.data } }); })
      .catch((e) => { setUser(false); navigate("/admin/login", { replace: true, state: { error: errorText(e) } }); });
  }, [hash, navigate, setUser]);

  return <div className="grid min-h-screen place-items-center text-ink/60" data-testid="auth-callback">Signing you in…</div>;
}
